import { render, staticRenderFns } from "./GreenPhone.vue?vue&type=template&id=8eadff26&scoped=true"
import script from "./GreenPhone.vue?vue&type=script&lang=js"
export * from "./GreenPhone.vue?vue&type=script&lang=js"
import style0 from "./GreenPhone.vue?vue&type=style&index=0&id=8eadff26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eadff26",
  null
  
)

export default component.exports